import React, { useRef, useState, useEffect } from 'react';
import './FadeInSection.css';

const FadeInSection = ({ children, direction = 'fade-up', delay = 0 }) => {
    const domRef = useRef();
    const [isVisible, setVisible] = useState(false);

    useEffect(() => {
        const observer = new IntersectionObserver(
            entries => {
                entries.forEach(entry => {
                    if (entry.isIntersecting) {
                        setTimeout(() => setVisible(true), delay);
                        observer.unobserve(entry.target); // chỉ trigger 1 lần
                    }
                });
            },
            {
                threshold: 0.01,
                root: null,
                rootMargin: '0px 0px -20px 0px'
            }
        );
        if (domRef.current) {
            observer.observe(domRef.current);
        }

        return () => {
            if (domRef.current) {
                observer.unobserve(domRef.current);
            }
        };
    }, [delay]);

    return (
        <div
            className={`fade-section ${direction} ${isVisible ? 'is-visible' : ''}`}
            ref={domRef}
        >
            {children}
        </div>
    );
};

export default FadeInSection;
